import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { HeatmapModalPage } from './heatmap-modal.page';
import { HeatmapHelpComponent } from './heatmap-help/heatmap-help.component';
import { SceneHeatmapComponent } from './scene-heatmap/scene-heatmap.component';
import { NoSceneComponent } from './no-scene/no-scene.component';
import { NgxPaginationModule } from 'ngx-pagination';

const routes: Routes = [
  {
    path: '',
    component: HeatmapModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NgxPaginationModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    HeatmapModalPage,
    HeatmapHelpComponent,
    SceneHeatmapComponent,
    NoSceneComponent
  ]
})
export class HeatmapModalPageModule { }
